import {DateTimePicker, DateTimePickerProps, LocalizationProvider} from '@mui/x-date-pickers';
import React from 'react';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {Typography} from '@mui/material';

export interface AppDateTimePickerProps extends DateTimePickerProps<Date, any> {
    label: string;
    required: boolean;
}

export const AppDateTimePicker: React.FC<AppDateTimePickerProps> = ({label, required, ...rest}) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Typography variant="body2" style={{marginBottom: '5px'}}>
                {label} {required && <span style={{color: 'red'}}>*</span>}
            </Typography>
            <DateTimePicker
                slotProps={{
                    textField: {
                        fullWidth: true,
                        size: 'small',
                    },
                }}
                {...rest}
            />
        </LocalizationProvider>
    );
};

export default AppDateTimePicker;
